import SummaryRow from '../../components/Summary/SummaryRow';
import { useAppSelector } from '../../hooks';
import useTranslation from '../../hooks/useTranslation';
import { selectFieldValue } from '../../store/applicationform/applicationFormSelectors';
import {
    APPLICANT_AGE_CHILD_FIELD_PREFIX,
    CHILD_COUNT_SELECTOR_FIELD_NAME,
    MAX_CHILDREN,
} from '../../store/applicationform/childAgeGroupUtil';

/**
 * Shows the DK life-situation children overview on the submit summary: the total
 * count and a row per child with the age entered for them.
 */
const ChildAgeGroupSummaryRows = () => {
    const translate = useTranslation();
    const selectValue = useAppSelector(selectFieldValue);
    const rawChildCount = Number(selectValue(CHILD_COUNT_SELECTOR_FIELD_NAME)) || 0;
    const childCount = Math.min(Math.max(rawChildCount, 0), MAX_CHILDREN);

    if (!childCount) {
        return null;
    }

    return (
        <>
            <SummaryRow
                label={translate('page.submit.number-of-children.label')}
                value={childCount.toString()}
                showEditButton={false}
            />
            {Array.from({ length: childCount }, (_, index) => index + 1).map((childNumber) => (
                <SummaryRow
                    key={childNumber}
                    label={translate('page.living-condition.subtitle.child-age', { index: childNumber })}
                    value={selectValue(`${APPLICANT_AGE_CHILD_FIELD_PREFIX}${childNumber}`).toString()}
                    showEditButton={false}
                />
            ))}
        </>
    );
};

export default ChildAgeGroupSummaryRows;
